import { useContext } from "react";
import { createContext, useEffect, useReducer } from "react";
import {
	HOME_SECTIONS_REDUCER_CREATE,
	HOME_SECTIONS_REDUCER_DELETE,
	HOME_SECTIONS_REDUCER_GET_ALL,
	HOME_SECTIONS_REDUCER_UPDATE,
} from "../common/constants";
import { HomeSectionsReducer } from "../Reducers/HomeSectionsReducer";
import { LoadingContext } from "./LoadingContext";

export const HomeSectionsContext = createContext();

const HomeSectionsContextProvider = (props) => {
	const [homeSectionsData, setHomeSectionsDataDispatch] = useReducer(HomeSectionsReducer, []);
	const { loadingData, setLoadingData } = useContext(LoadingContext);

	const getAllHomeSectionsFromContext = (cb) => {
		setLoadingData({
			is_loading: true,
			message: "Loading all home sections....",
		});

		setHomeSectionsDataDispatch({
			type: HOME_SECTIONS_REDUCER_GET_ALL,
			loading: true,
			dispatch: setHomeSectionsDataDispatch,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const createNewHomeSectionFromContext = (data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Creating new home section....",
		});

		setHomeSectionsDataDispatch({
			type: HOME_SECTIONS_REDUCER_CREATE,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const updateHomeSectionFromContext = (id, data, cb) => {
		setLoadingData({
			is_loading: true,
			message: "Updating home section....",
		});

		setHomeSectionsDataDispatch({
			type: HOME_SECTIONS_REDUCER_UPDATE,
			id,
			data,
			callback: () => {
				setLoadingData({
					is_loading: false,
					message: "",
				});
				cb && cb();
			},
		});
	};

	const deleteHomeSectionFromContext = (id, successCb = () => {}, failedCb = () => {}) => {
		setLoadingData({
			is_loading: true,
			message: "Deleting Home Section...",
		});

		setHomeSectionsDataDispatch({
			type: HOME_SECTIONS_REDUCER_DELETE,
			dispatch: setHomeSectionsDataDispatch,
			loading: true,
			id,
			successCb,
			failedCb,
			loadingCb: () =>
				setLoadingData({
					is_loading: false,
					message: "",
				}),
		});
	};

	return (
		<HomeSectionsContext.Provider
			value={{
				homeSectionsData,
				getAllHomeSectionsFromContext,
				createNewHomeSectionFromContext,
				updateHomeSectionFromContext,
				deleteHomeSectionFromContext,
			}}
		>
			{props.children}
		</HomeSectionsContext.Provider>
	);
};

export default HomeSectionsContextProvider;
